const routes = [
  //医疗员工管理
  {
    path: "/staffManagement",
    name: 'staffManagement',
    meta: {
      title: '员工管理',
      hasBack: false
    },
    component: () => import('@/pages/medical/staffManagement/index.vue'),
  },
  //潜在客户管理
  {
    path: "/potentialUser",
    name: 'potentialUser',
    meta: {
      title: '潜在客户',
      hasBack: false
    },
    component: () => import('@/pages/medical/potentialUser/index.vue'),
  },
];
export default routes;
